<div class="workspace-page">
  <div class="workspace-sticky-base">
  <div class="workspace-topbar workspace-topbar-v80">
    <div>
      <h1>Workspace de Perícia<span *ngIf="periciaAtual()"> - {{ periciaAtual()?.titulo }}</span></h1>
      <p *ngIf="!periciaAtual()">Cadastro, consulta e abas operacionais da perícia selecionada.</p>
      <p *ngIf="periciaAtual()">
        {{ periciaAtual()?.codigo }} • {{ periciaAtual()?.numero_processo || 'Sem processo informado' }} • {{ periciaAtual()?.cliente || 'Sem cliente informado' }}
      </p>
    </div>

    <button
      type="button"
      class="btn-primary btn-pesquisar-topo"
      *ngIf="periciaAtual() && modo() !== 'novo' && !mostrarPesquisaPericias"
      (click)="voltarPesquisaPericias()">
      🔍 Pesquisar
    </button>
  </div>

  <div class="workspace-nav" *ngIf="periciaAtual() || modo() === 'novo'">
    <div class="chrome-tabs chrome-tabs-principais">
      <button
        type="button"
        *ngFor="let grupo of gruposWorkspaceVisiveis()"
        [class.ativa]="grupoWorkspaceAtual() === grupo.titulo"
        (click)="selecionarGrupoWorkspace(grupo.titulo)">
        <span>{{ grupo.titulo }}</span>
      </button>
    </div>

    <div class="workspace-subtabs" *ngIf="subabasGrupoAtual().length > 1">
      <button
        type="button"
        *ngFor="let subaba of subabasGrupoAtual(); let idx = index"
        [class.ativa]="abaAtiva() === subaba"
        (click)="selecionarAba(subaba)">
        <span class="subtab-step">{{ idx + 1 }}</span>
        <span class="subtab-icon">{{ iconeAbaWorkspace(subaba) }}</span>
        <span class="subtab-copy">
          <strong>{{ rotuloAbaWorkspace(subaba) }}</strong>
          <small>{{ descricaoAbaWorkspace(subaba) }}</small>
        </span>
      </button>
    </div>
  </div>
  </div>

  <div class="consulta-pericias" *ngIf="modo() !== 'novo' && mostrarPesquisaPericias">
    <div class="consulta-grid">
      <div class="field filtro-ano">
        <label>Ano do cadastro/código</label>
        <select [(ngModel)]="anoFiltro" (ngModelChange)="aplicarFiltroPericias()">
          <option value="">Todos os anos</option>
          <option *ngFor="let ano of anosDisponiveis()" [value]="ano">{{ ano }}</option>
        </select>
      </div>

      <div class="field filtro-mes">
        <label>Mês do cadastro</label>
        <select [(ngModel)]="mesFiltro" (ngModelChange)="aplicarFiltroPericias()">
          <option value="">Todos os meses</option>
          <option *ngFor="let mes of mesesFiltro" [value]="mes.valor">{{ mes.nome }}</option>
        </select>
      </div>

      <div class="field filtro-pesquisa">
        <label>Pesquisar perícia</label>
        <div class="search-inline-v9145">
          <input
            [(ngModel)]="pesquisaPericia"
            (keyup.enter)="executarPesquisaPericias()"
            placeholder="Digite qualquer parte do código, título, processo ou cliente">
          <button type="button" class="btn-search-icon-v9145" title="Pesquisar perícias" (click)="executarPesquisaPericias()">🔍</button>
        </div>
      </div>

      <div class="consulta-actions consulta-actions-topo">
<button type="button" class="btn-primary" (click)="novaPericiaAssistida()">Nova perícia com assistente</button>
      </div>
    </div>
    <div class="resultado-pericias" *ngIf="mostrarListaPericias">
      <div class="resultado-header">
        <div>
          <strong>Perícias encontradas</strong>
          <span>{{ periciasFiltradas().length }} registro(s)</span>
        </div>
</div>

      <div class="pericias-lista" *ngIf="periciasFiltradas().length; else nenhumaPericiaTpl">
        <button
          type="button"
          class="pericia-card"
          *ngFor="let p of periciasFiltradas()"
          [class.selecionada]="p.id === periciaSelecionadaId"
          (click)="abrirPericia(p)">
          <span class="pericia-codigo">{{ p.codigo }}</span>
          <span class="pericia-titulo">{{ p.titulo }}</span>
          <span class="pericia-meta">{{ p.numero_processo || 'Sem processo' }} • {{ p.cliente || 'Sem cliente' }}</span>
          <span class="pericia-status">{{ p.status }}</span>
        </button>
      </div>

      <ng-template #nenhumaPericiaTpl>
        <div class="empty-list">Nenhuma perícia encontrada para os filtros informados.</div>
      </ng-template>
    </div>
  </div>

  <div class="selecione-uma-pericia" *ngIf="!periciaAtual() && modo() !== 'novo' && !mostrarListaPericias && abaAtiva() !== 'Fluxo Assistido'">
    Selecione uma perícia na lista acima ou clique em <b>Nova perícia</b>.
  </div>

  <div class="alerts">
    <div class="alert erro" *ngIf="erro()">{{ erro() }}</div>
    <div class="alert ok" *ngIf="mensagem()">{{ mensagem() }}</div>
  </div>

  <ng-container *ngIf="periciaAtual() || modo() === 'novo' || abaAtiva() === 'Fluxo Assistido'">
  <div class="panel" *ngIf="!carregando(); else loadingTpl">
    <div class="alert aviso v67-aviso-nova-pericia" *ngIf="modo() === 'novo' && abaAtiva() !== 'Perícia'">
      Salve primeiro os Dados da Perícia. Depois do cadastro, o sistema abre a aba Nomeação para registrar o aceite ou não aceite.
    </div>
    <ng-container *ngIf="abaAtiva() === 'Perícia'; else fluxoTpl">
      <div class="secao-pericia">
        <div class="section-title">
          <div>
            <h2>{{ modo() === 'novo' ? 'Nova Perícia' : 'Dados da Perícia' }}</h2>
            <p>Campos principais do cadastro. Tipo, datas e status são selecionáveis.</p>
          </div>
          <div class="button-group">
            <button type="button" class="btn-light" *ngIf="modo() === 'novo'" (click)="cancelarEdicao()">Cancelar</button>
            <button type="button" class="btn-primary" *ngIf="modo() === 'novo'" (click)="salvar()">Salvar nova perícia</button>

            <button type="button" class="btn-primary" *ngIf="modo() !== 'novo' && periciaAtual()" (click)="salvarAtual()">Salvar alterações</button>
            <button type="button" class="btn-danger" *ngIf="modo() !== 'novo' && periciaAtual()" (click)="excluirAtual()">Excluir</button>
          </div>
        </div>

        <div class="form-card bloco-principal">
          <div class="form-card-title">Identificação</div>
          <div class="form-grid improved-form">
            <div class="field codigo-field">
              <label>Código</label>
              <input
                [ngModel]="modo() === 'novo' ? codigoPreviewNovaPericia() : formulario.codigo"
                readonly
                class="input-readonly"
                placeholder="Automático ao salvar">
              <small>{{ modo() === 'novo' ? 'Gerado automaticamente ao salvar.' : 'Código controlado pelo sistema.' }}</small>
            </div>

            <div class="field titulo-field">
              <label>Título</label>
              <input [(ngModel)]="formulario.titulo" placeholder="Ex.: Apuração de haveres">
            </div>

            <div class="field tipo-field">
              <label>Tipo de perícia</label>
              <select [(ngModel)]="formulario.tipo_pericia">
                <option *ngFor="let tipo of tiposPericia" [value]="tipo">{{ tipo }}</option>
              </select>
            </div>

            <div class="field cliente-field">
              <label>Cliente</label>
              <input [(ngModel)]="formulario.cliente" placeholder="Nome do cliente">
            </div>

            <div class="field processo-field">
              <label>Número do processo</label>
              <input [(ngModel)]="formulario.numero_processo" placeholder="0000000-00.0000.0.00.0000">
            </div>

            <div class="field vara-field">
              <label>Vara ou câmara</label>
              <input [(ngModel)]="formulario.vara_ou_camara" placeholder="Vara, câmara ou órgão">
            </div>
          </div>
        </div>

        <div class="form-card bloco-prazos">
          <div class="form-card-title">Prazos e controle</div>
          <div class="form-grid date-status-grid">
            <div class="field">
              <label>Data início</label>
              <input type="date" [(ngModel)]="formulario.data_inicio">
            </div>

            <div class="field">
              <label>Data base</label>
              <input type="date" [(ngModel)]="formulario.data_base">
            </div>

            <div class="field">
              <label>Prazo laudo</label>
              <input type="date" [(ngModel)]="formulario.prazo_laudo">
            </div>

            <div class="field status-field">
              <label>Status</label>
              <select [(ngModel)]="formulario.status">
                <option *ngFor="let status of statusOpcoes" [value]="status">{{ status }}</option>
              </select>
            </div>

            <div class="status-preview">
              <span class="status-pill" [ngClass]="classeStatus(formulario.status)">{{ formulario.status }}</span>
            </div>
          </div>
        </div>

        <div class="form-card bloco-textos">
          <div class="form-card-title">Objeto e descrição</div>
          <div class="text-grid">
            <div class="field">
              <label>Objeto inicial</label>
              <textarea rows="4" [(ngModel)]="formulario.objeto_inicial" placeholder="Descreva o objeto inicial da perícia"></textarea>
            </div>
            <div class="field">
              <label>Descrição</label>
              <textarea rows="4" [(ngModel)]="formulario.descricao" placeholder="Observações, escopo e informações complementares"></textarea>
            </div>
          </div>
        </div>
        </div>

      
    </ng-container>

    
    <ng-template #fluxoTpl>
      <ng-container *ngIf="abaAtiva() === 'Nomeação'; else fluxoAssistidoTpl">
        <div class="retorno-nomeacao-page">
          <div class="section-title">
            <div>
              <h2>Nomeação</h2>
              <p>Registre o aceite ou não aceite da nomeação e gere a manifestação ao Juízo.</p>
            </div>
            <div class="button-group">
              <button type="button" class="btn-light" (click)="aplicarModeloRetornoNomeacao()">Aplicar modelo</button>
              <button type="button" class="btn-primary" (click)="salvarRetornoNomeacao()" [disabled]="retornoNomeacaoSalvando">Salvar</button>
              <button type="button" class="btn-light" (click)="visualizarPreviewRetornoNomeacao()" [disabled]="retornoNomeacaoSalvando">Preview</button>
            </div>
          </div>

          <div class="retorno-status-card">
            <div>
              <span>Status da nomeação</span>
              <strong>{{ retornoNomeacaoForm.status_nomeacao }}</strong>
            </div>
            <div>
              <span>Tipo de retorno</span>
              <strong>{{ retornoNomeacaoForm.tipo_retorno }}</strong>
            </div>
            <div>
              <span>Status do protocolo</span>
              <strong>{{ retornoNomeacaoForm.status_protocolo }}</strong>
            </div>
          </div>

          <div class="retorno-form-card">
            <div class="form-card-title">Controle da resposta ao Juízo</div>
            <div class="retorno-grid">
              <div class="field">
                <label>Status da nomeação</label>
                <select [(ngModel)]="retornoNomeacaoForm.status_nomeacao" (ngModelChange)="onStatusNomeacaoChange($event)">
                  <option *ngFor="let s of statusNomeacaoOpcoes" [value]="s">{{ s }}</option>
                </select>
              </div>
              <div class="field">
                <label>Tipo de retorno</label>
                <select [(ngModel)]="retornoNomeacaoForm.tipo_retorno" (ngModelChange)="onTipoRetornoNomeacaoChange($event)">
                  <option *ngFor="let tipo of tiposRetornoNomeacao" [value]="tipo">{{ tipo }}</option>
                </select>
              </div>
              <div class="field">
                <label>Data da intimação</label>
                <input type="date" [(ngModel)]="retornoNomeacaoForm.data_intimacao">
              </div>
              <div class="field">
                <label>Data da resposta</label>
                <input type="date" [(ngModel)]="retornoNomeacaoForm.data_resposta">
              </div>
              <div class="field">
                <label>Status do protocolo</label>
                <select [(ngModel)]="retornoNomeacaoForm.status_protocolo">
                  <option *ngFor="let s of statusProtocoloRetorno" [value]="s">{{ s }}</option>
                </select>
              </div>
              <div class="field wide">
                <label>Motivo do não aceite / observação do aceite</label>
                <textarea rows="3" [(ngModel)]="retornoNomeacaoForm.motivo_nao_aceite" placeholder="Ex.: ausência de especialidade técnica, vínculo anterior, conflito de interesse, agenda/prazo ou outro motivo justificado"></textarea>
              </div>
              <div class="field wide">
                <label>Fundamentação</label>
                <textarea rows="3" [(ngModel)]="retornoNomeacaoForm.fundamentacao"></textarea>
              </div>
              <div class="field wide">
                <label>Texto da manifestação ao Juízo</label>
                <textarea rows="13" [(ngModel)]="retornoNomeacaoForm.texto_manifestacao" placeholder="Clique em Aplicar modelo para gerar um texto base e ajuste antes de exportar."></textarea>
              </div>
              <div class="field wide">
                <label>Observações internas</label>
                <textarea rows="3" [(ngModel)]="retornoNomeacaoForm.observacoes_internas" placeholder="Controle interno: prazo, conversa, risco, motivo resumido, número do protocolo etc."></textarea>
              </div>
            </div>
            <div class="retorno-actions-bottom">
              <button type="button" class="btn-light" (click)="aplicarModeloRetornoNomeacao()">Aplicar modelo selecionado</button>
              <button type="button" class="btn-primary" (click)="salvarRetornoNomeacao()" [disabled]="retornoNomeacaoSalvando">Salvar</button>
              <button type="button" class="btn-light" (click)="visualizarPreviewRetornoNomeacao()" [disabled]="retornoNomeacaoSalvando">Abrir preview</button>
            </div>
          </div>

          <div class="honorarios-preview-modal" *ngIf="retornoNomeacaoPreviewAberto">
            <div class="preview-backdrop" (click)="fecharPreviewRetornoNomeacao()"></div>
            <div class="preview-window preview-window-retorno">
              <div class="preview-window-header"><div><strong>Preview — Nomeação</strong><small>Exporte a manifestação em PDF, Word ou HTML.</small></div><button type="button" class="btn-close-preview" (click)="fecharPreviewRetornoNomeacao()">×</button></div>
              <div class="preview-window-actions"><label>Formato</label><select [(ngModel)]="retornoNomeacaoFormatoExportacao"><option value="pdf">PDF</option><option value="docx">Word (.docx)</option><option value="html">HTML</option></select><button type="button" class="btn-primary" (click)="exportarRetornoNomeacao()" [disabled]="retornoNomeacaoSalvando">Exportar manifestação</button><button type="button" class="btn-light" (click)="fecharPreviewRetornoNomeacao()">Fechar e voltar</button></div>
              <iframe class="honorarios-preview-frame-modal" [srcdoc]="retornoNomeacaoPreviewHtml"></iframe>
            </div>
          </div>
        </div>
      </ng-container>



      <!-- v92.2.14 — Retorno rápido ao assistente quando o usuário estiver em uma etapa interna -->
      <div class="bpmn-return-strip-v92214"
           *ngIf="periciaAtual() && abaAtiva() !== 'Fluxo Assistido'">
        <div>
          <strong>Você está em: {{ abaAtiva() }}</strong>
          <span>Retorne ao roteiro visual da perícia para continuar o passo a passo.</span>
        </div>
        <button type="button"
                class="btn-light bpmn-return-btn-v92214"
                (click)="abaAtiva.set('Fluxo Assistido')">
          ← Voltar ao assistente
        </button>
      </div>

      <ng-template #fluxoAssistidoTpl>
        <ng-container *ngIf="abaAtiva() === 'Fluxo Assistido'; else fluxoRealTpl">
          <div class="fluxo-assistido-page bpmn-nbc-page bpmn-v922">
            <div class="section-title bpmn-header-v922">
              <div>
                <h2>Assistente de Perícia BPMN</h2>
                <p>Fluxo premium guiado: clique em <strong>Início</strong>, preencha o cadastro e avance pelo roteiro com decisões e exceções bem posicionadas.</p>
              </div>
              <div class="button-group">
                <button type="button" class="btn-primary" (click)="novaPericiaAssistida()">Nova perícia pelo BPMN</button>
              </div>
            </div>

            <div class="bpmn-context-v922" *ngIf="periciaAtual(); else semPericiaBpmnTpl">
              <div>
                <span>Perícia selecionada</span>
                <strong>{{ periciaAtual()?.codigo }} — {{ periciaAtual()?.titulo }}</strong>
                <small>{{ periciaAtual()?.numero_processo || 'Sem processo informado' }} • {{ periciaAtual()?.cliente || 'Sem cliente informado' }}</small>
              </div>
              <div>
                <span>Tipo de atuação</span>
                <strong>{{ tipoFluxoBpmnRotulo() }}</strong>
                <small>O fluxo muda para perito do juízo, assistente técnico ou extrajudicial.</small>
              </div>
            </div>

            <ng-template #semPericiaBpmnTpl>
              <div class="bpmn-empty-v922">
                <div>
                  <strong>Nenhuma perícia selecionada</strong>
                  <p>Escolha uma perícia existente ou inicie uma nova perícia pelo roteiro assistido.</p>
                </div>
                <div class="button-group">
                  <button type="button" class="btn-light" (click)="ctaSemPericiaBpmn()">Selecionar perícia existente</button>
                  <button type="button" class="btn-primary" (click)="novaPericiaAssistida()">Nova perícia pelo assistente</button>
                </div>
              </div>
            </ng-template>

            <!-- ==========================================================
                 v92.2.22 — cadeado visual, legenda de status e motivo do bloqueio
                 FRONTEND ONLY — sem alteração de banco e sem alteração de backend
                 ========================================================== -->
            <div class="bpmn-workbench bpmn-v92211-workbench bpmn-v92212-workbench">

              <main class="bpmn-v92211-flow-card" aria-label="Fluxo visual assistido premium da perícia">
                <header class="bpmn-v92211-flow-header">
                  <div class="bpmn-v92211-flow-title-wrap">
                    <div class="bpmn-v92211-flow-icon">📘</div>
                    <div>
                      <h2>Fluxo assistido da perícia</h2>
                      <p>Roteiro visual para condução técnica do trabalho pericial.</p>
                    </div>
                  </div>

                  <div class="bpmn-v92222-header-actions">
                    <div class="bpmn-v92211-flow-badge">
                      <span class="badge-dot"></span>
                      Assistente ativo
                    </div>

                    <div class="bpmn-status-legend-v92222" aria-label="Legenda de status do fluxo">
                      <span class="legend-item legend-ok">Concluída</span>
                      <span class="legend-item legend-run">Em andamento</span>
                      <span class="legend-item legend-wait">Aguardando</span>
                      <span class="legend-item legend-lock">Bloqueada</span>
                    </div>
                  </div>
                </header>

                <div class="bpmn-v92211-flow-scroll">
                  <div class="bpmn-v92211-canvas">

                    <!-- PLANEJAMENTO / GATES INICIAIS -->
                    <section class="pd-flow-row pd-flow-row-planejamento">
                      <aside class="pd-flow-stage">
                        <div class="pd-flow-stage-icon">◎</div>
                        <div>
                          <strong>Planejamento</strong>
                          <span>entrada e estratégia</span>
                        </div>
                      </aside>

                      <div class="pd-flow-stage-content pd-flow-stage-content-top pd-top-flow-v92216">
                        <div class="pd-top-vertical-flow">

                          <button type="button"
                                  class="pd-start-circle"
                                  [ngClass]="classeSvgNoBpmn('INICIO')"
                                  title="Início — iniciar perícia"
                                  (click)="selecionarNoBpmnPorCodigo('INICIO'); abrirNoBpmnPorCodigo('INICIO')">
                            <span class="pd-start-circle-ring">
                              <span class="pd-start-circle-play">▶</span>
                            </span>
                            <strong>Início</strong>
                            <small>iniciar</small>
                          </button>

                          <div class="pd-arrow-down pd-top-arrow"></div>

                          <button type="button"
                                  class="pd-flow-card pd-flow-card-top-wide"
                                  [ngClass]="classeSvgNoBpmn('CADASTRO')"
                                  (click)="selecionarNoBpmnPorCodigo('CADASTRO'); abrirNoBpmnPorCodigo('CADASTRO')">
                            <div class="pd-flow-card-text pd-flow-card-text-centered">
                              <strong>Cadastro da Perícia</strong>
                              <span>objeto, partes, prazo e processo</span>
                            </div>
                          </button>

                          <div class="pd-arrow-down pd-top-arrow-short"></div>

                          <div class="pd-top-atuacao-wrap">
                            <button type="button"
                                    class="pd-diamond-card pd-diamond-top pd-diamond-atuacao"
                                    [class.ativo]="!!periciaAtual()"
                                    (click)="selecionarNoBpmnPorCodigo('CADASTRO'); abrirNoBpmnPorCodigo('CADASTRO')">
                              <span>Tipo de atuação</span>
                              <strong>{{ tipoFluxoBpmnRotulo() }}</strong>
                            </button>
                          </div>

                          <div class="pd-arrow-down pd-top-arrow-short"></div>

                          <button type="button"
                                  class="pd-flow-card pd-flow-card-top-wide"
                                  [ngClass]="classeSvgNoBpmn('EQUIPE')"
                                  (click)="selecionarNoBpmnPorCodigo('EQUIPE'); abrirNoBpmnPorCodigo('EQUIPE')">
                            <div class="pd-flow-card-text pd-flow-card-text-centered">
                              <strong>Equipe / Papéis</strong>
                              <span>definir participantes e papéis</span>
                            </div>
                          </button>

                          <div class="pd-arrow-down pd-top-arrow-short"></div>

                          <ng-container *ngIf="tipoFluxoBpmnRotulo() === 'Perito do Juízo'; else fluxoDiretoNaoJudicial">
                            <div class="pd-top-decision-wrap">
                              <button type="button"
                                      class="pd-diamond-card pd-diamond-top"
                                      [ngClass]="classeSvgNoBpmn('DECISAO_NOMEACAO')"
                                      (click)="selecionarNoBpmnPorCodigo('DECISAO_NOMEACAO'); abrirNoBpmnPorCodigo('DECISAO_NOMEACAO')">
                                <span>Aceita nomeação?</span>
                                <strong>Sim / Não</strong>
                              </button>

                              <div class="pd-top-branch-right">
                                <span class="pd-top-branch-label">Não</span>
                                <div class="pd-arrow-right pd-top-branch-arrow"></div>
                                <button type="button"
                                        class="pd-flow-card pd-flow-card-branch-danger"
                                        [ngClass]="classeSvgNoBpmn('NAO_ACEITA')"
                                        (click)="selecionarNoBpmnPorCodigo('NAO_ACEITA'); abrirNoBpmnPorCodigo('NAO_ACEITA')">
                                  <div class="pd-flow-card-text pd-flow-card-text-centered">
                                    <strong>Encerrar / recusa</strong>
                                    <span>recusa justificada</span>
                                  </div>
                                </button>
                              </div>
                            </div>

                            <span class="pd-top-sim-label pd-sim-nomeacao">Sim</span>
                            <div class="pd-arrow-down pd-top-arrow-short pd-arrow-sim-nomeacao"></div>

                            <button type="button"
                                    class="pd-flow-card pd-flow-card-top-wide"
                                    [ngClass]="classeSvgNoBpmn('HONORARIOS')"
                                    (click)="selecionarNoBpmnPorCodigo('HONORARIOS'); abrirNoBpmnPorCodigo('HONORARIOS')">
                              <div class="pd-flow-card-text pd-flow-card-text-centered">
                                <strong>Honorários</strong>
                                <span>estimar e propor</span>
                              </div>
                            </button>

                            <div class="pd-arrow-down pd-top-arrow-short"></div>

                            <div class="pd-top-decision-wrap">
                              <button type="button"
                                      class="pd-diamond-card pd-diamond-top"
                                      [ngClass]="classeSvgNoBpmn('DECISAO_HONORARIOS')"
                                      (click)="selecionarNoBpmnPorCodigo('DECISAO_HONORARIOS'); abrirNoBpmnPorCodigo('DECISAO_HONORARIOS')">
                                <span>Honorários aprovados?</span>
                                <strong>Sim / Não</strong>
                              </button>

                              <div class="pd-top-branch-right">
                                <span class="pd-top-branch-label">Não</span>
                                <div class="pd-arrow-right pd-top-branch-arrow"></div>
                                <button type="button"
                                        class="pd-flow-card pd-flow-card-branch-warn"
                                        [ngClass]="classeSvgNoBpmn('AGUARDAR_HONORARIOS')"
                                        (click)="selecionarNoBpmnPorCodigo('AGUARDAR_HONORARIOS'); abrirNoBpmnPorCodigo('AGUARDAR_HONORARIOS')">
                                  <div class="pd-flow-card-text pd-flow-card-text-centered">
                                    <strong>Aguardar / Ajustar</strong>
                                    <span>revisar e reenviar</span>
                                  </div>
                                </button>
                              </div>
                            </div>

                            <span class="pd-top-sim-label pd-sim-honorarios">Sim</span>
                            <div class="pd-arrow-down pd-top-arrow-short pd-arrow-sim-honorarios"></div>

                            <button type="button"
                                    class="pd-flow-card pd-flow-card-top-wide pd-flow-card-plan-final"
                                    [ngClass]="classeSvgNoBpmn('PLANEJAMENTO')"
                                    (click)="selecionarNoBpmnPorCodigo('PLANEJAMENTO'); abrirNoBpmnPorCodigo('PLANEJAMENTO')">
                              <div class="pd-flow-card-text pd-flow-card-text-centered">
                                <strong>Planejamento</strong>
                                <span>definir estratégia da perícia</span>
                              </div>
                            </button>
                          </ng-container>

                          <ng-template #fluxoDiretoNaoJudicial>
                            <button type="button"
                                    class="pd-flow-card pd-flow-card-skip-success"
                                    (click)="selecionarNoBpmnPorCodigo('PLANEJAMENTO'); abrirNoBpmnPorCodigo('PLANEJAMENTO')">
                              <div class="pd-flow-card-text pd-flow-card-text-centered">
                                <strong>Fluxo simplificado</strong>
                                <span>Extrajudicial / Assistente: seguir direto para o Planejamento</span>
                              </div>
                            </button>

                            <div class="pd-arrow-down pd-top-arrow-short pd-arrow-skip-success"></div>

                            <button type="button"
                                    class="pd-flow-card pd-flow-card-top-wide pd-flow-card-plan-final pd-flow-card-plan-success"
                                    [ngClass]="classeSvgNoBpmn('PLANEJAMENTO')"
                                    (click)="selecionarNoBpmnPorCodigo('PLANEJAMENTO'); abrirNoBpmnPorCodigo('PLANEJAMENTO')">
                              <div class="pd-flow-card-text pd-flow-card-text-centered">
                                <strong>Planejamento</strong>
                                <span>definir estratégia da perícia</span>
                              </div>
                            </button>
                          </ng-template>

                          <div class="pd-arrow-down pd-arrow-after-top"></div>
                        </div>
                      </div>
                    </section>

                    <!-- PREPARAÇÃO DA EXECUÇÃO -->
                    <section class="pd-flow-row pd-flow-row-preparacao">
                      <aside class="pd-flow-stage">
                        <div class="pd-flow-stage-icon">▣</div>
                        <div>
                          <strong>Preparação</strong>
                          <span>da execução</span>
                        </div>
                      </aside>

                      <div class="pd-flow-stage-content">
                        <div class="pd-flow-group pd-flow-group-preparacao">
                          <div class="pd-flow-group-header">
                            <h3>Preparação da execução</h3>
                            <p>quesitos, documentos e diligências em paralelo para alimentar os programas de trabalho</p>
                          </div>

                          <div class="pd-prep-grid">
                            <button type="button"
                                    class="pd-flow-card pd-flow-card-small"
                                    [ngClass]="classeSvgNoBpmn('QUESITOS')"
                                    (click)="selecionarNoBpmnPorCodigo('QUESITOS'); abrirNoBpmnPorCodigo('QUESITOS')">
                              <div class="pd-flow-card-icon">?</div>
                              <div class="pd-flow-card-text">
                                <strong>Quesitos</strong>
                                <span>pontos técnicos</span>
                              </div>
                            </button>

                            <button type="button"
                                    class="pd-flow-card pd-flow-card-small"
                                    [ngClass]="classeSvgNoBpmn('DOCUMENTOS')"
                                    (click)="selecionarNoBpmnPorCodigo('DOCUMENTOS'); abrirNoBpmnPorCodigo('DOCUMENTOS')">
                              <div class="pd-flow-card-icon">▤</div>
                              <div class="pd-flow-card-text">
                                <strong>Documentos</strong>
                                <span>provas e anexos</span>
                              </div>
                            </button>

                            <button type="button"
                                    class="pd-flow-card pd-flow-card-small"
                                    [ngClass]="classeSvgNoBpmn('DILIGENCIAS')"
                                    (click)="selecionarNoBpmnPorCodigo('DILIGENCIAS'); abrirNoBpmnPorCodigo('DILIGENCIAS')">
                              <div class="pd-flow-card-icon">⇄</div>
                              <div class="pd-flow-card-text">
                                <strong>Diligências</strong>
                                <span>solicitações</span>
                              </div>
                            </button>
                          </div>

                          <div class="pd-prep-connectors">
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>

                          <button type="button"
                                  class="pd-flow-card pd-flow-card-programas"
                                  [ngClass]="classeSvgNoBpmn('PROGRAMAS')"
                                  (click)="selecionarNoBpmnPorCodigo('PROGRAMAS'); abrirNoBpmnPorCodigo('PROGRAMAS')">
                            <div class="pd-flow-card-icon">☑</div>
                            <div class="pd-flow-card-text">
                              <strong>Programas / Tarefas</strong>
                              <span>procedimentos, cronograma e execução assistida</span>
                            </div>
                          </button>
                        </div>

                        <div class="pd-arrow-down pd-arrow-after-group"></div>
                      </div>
                    </section>

                    <!-- EXECUÇÃO TÉCNICA -->
                    <section class="pd-flow-row pd-flow-row-execucao">
                      <aside class="pd-flow-stage">
                        <div class="pd-flow-stage-icon">▥</div>
                        <div>
                          <strong>Execução</strong>
                          <span>técnica</span>
                        </div>
                      </aside>

                      <div class="pd-flow-stage-content">
                        <div class="pd-flow-group pd-flow-group-execucao">
                          <div class="pd-flow-group-header">
                            <h3>Execução técnica — resultados e evidências</h3>
                            <p>execuções analíticas, achados e matriz de evidências em sequência limpa</p>
                          </div>

                          <div class="pd-exec-chain">
                            <button type="button"
                                    class="pd-flow-card pd-flow-card-exec"
                                    [ngClass]="classeSvgNoBpmn('EXECUCOES')"
                                    (click)="selecionarNoBpmnPorCodigo('EXECUCOES'); abrirNoBpmnPorCodigo('EXECUCOES')">
                              <div class="pd-flow-card-icon">▥</div>
                              <div class="pd-flow-card-text">
                                <strong>Execuções</strong>
                                <span>analíticas</span>
                              </div>
                            </button>

                            <div class="pd-arrow-right"></div>

                            <button type="button"
                                    class="pd-flow-card pd-flow-card-exec"
                                    [ngClass]="classeSvgNoBpmn('ACHADOS')"
                                    (click)="selecionarNoBpmnPorCodigo('ACHADOS'); abrirNoBpmnPorCodigo('ACHADOS')">
                              <div class="pd-flow-card-icon">⌕</div>
                              <div class="pd-flow-card-text">
                                <strong>Achados</strong>
                                <span>constatações</span>
                              </div>
                            </button>

                            <div class="pd-arrow-right"></div>

                            <button type="button"
                                    class="pd-flow-card pd-flow-card-exec"
                                    [ngClass]="classeSvgNoBpmn('EVIDENCIAS')"
                                    (click)="selecionarNoBpmnPorCodigo('EVIDENCIAS'); abrirNoBpmnPorCodigo('EVIDENCIAS')">
                              <div class="pd-flow-card-icon">▦</div>
                              <div class="pd-flow-card-text">
                                <strong>Matriz</strong>
                                <span>evidências</span>
                              </div>
                            </button>

                            <div class="pd-arrow-right"></div>

                            <button type="button"
                                    class="pd-flow-card pd-flow-card-exec"
                                    [ngClass]="classeSvgNoBpmn('LAUDO')"
                                    (click)="selecionarNoBpmnPorCodigo('LAUDO'); abrirNoBpmnPorCodigo('LAUDO')">
                              <div class="pd-flow-card-icon">▧</div>
                              <div class="pd-flow-card-text">
                                <strong>Laudo / Parecer</strong>
                                <span>saída técnica</span>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </section>

                    <!-- CONCLUSÃO -->
                    <section class="pd-flow-row pd-flow-row-conclusao">
                      <aside class="pd-flow-stage">
                        <div class="pd-flow-stage-icon">✓</div>
                        <div>
                          <strong>Conclusão</strong>
                          <span>encerramento</span>
                        </div>
                      </aside>

                      <div class="pd-flow-stage-content">
                        <button type="button"
                                class="pd-final-line"
                                [ngClass]="classeSvgNoBpmn('FIM')"
                                (click)="selecionarNoBpmnPorCodigo('FIM'); abrirNoBpmnPorCodigo('FIM')">
                          <div class="pd-final-marker">
                            <span></span>
                          </div>
                          <strong>Fim</strong>
                        </button>
                      </div>
                    </section>

                  </div>
                </div>
              </main>

              <aside class="bpmn-side-panel bpmn-v92211-side-panel" *ngIf="noBpmnSelecionado() as no">
                <div class="bpmn-side-header bpmn-v92211-side-header">
                  <span [ngClass]="classeNoBpmn(no)">{{ no.tipo === 'decisao' ? 'Decisão' : no.tipo === 'inicio' ? 'Evento inicial' : no.tipo === 'fim' ? 'Evento final' : no.tipo === 'espera' ? 'Espera' : 'Tarefa' }}</span>
                  <h3>{{ no.titulo }}</h3>
                  <p>{{ no.subtitulo }}</p>
                </div>

                <div class="bpmn-status-box bpmn-v92211-status-box">
                  <strong>Status</strong>
                  <span class="status-pill" [ngClass]="classeFluxoAssistido(no.status)">{{ no.status }}</span>
                </div>

                <div class="bpmn-lock-reason-v92222" *ngIf="no.status === 'Bloqueada' || no.status === 'Encerrada'">
                  <strong>{{ no.status === 'Encerrada' ? 'Fluxo encerrado' : 'Fluxo bloqueado' }}</strong>
                  <p>{{ no.decisao }}</p>
                </div>

                <div class="bpmn-info-block bpmn-v92211-info-block">
                  <strong>Objetivo / condição</strong>
                  <p class="bpmn-v92212-texto-curto">{{ no.decisao }}</p>
                </div>

                <div class="bpmn-info-block compacto bpmn-v92211-info-block">
                  <strong>Perguntas orientadoras</strong>
                  <label *ngFor="let pergunta of (no.perguntas || []).slice(0, 3)">
                    <input type="checkbox">
                    <span>{{ pergunta }}</span>
                  </label>
                </div>

                <div class="bpmn-info-block nbc bpmn-v92211-info-block bpmn-v92211-nbc">
                  <strong>Norte NBC / metodologia pericial</strong>
                  <p class="bpmn-v92212-texto-curto">{{ no.referencia }}</p>
                </div>

                <div class="bpmn-info-block proxima bpmn-v92211-info-block">
                  <strong>Próxima ação</strong>
                  <p class="bpmn-v92212-texto-curto">{{ no.proximaAcao }}</p>
                </div>

                <div class="bpmn-actions bpmn-v92211-actions bpmn-v92213-actions">
                  <div class="bpmn-v92213-hint">
                    Clique em um bloco do fluxo para abrir a etapa. Nas telas internas, use <strong>Voltar ao assistente</strong> para retornar ao roteiro.
                  </div>
                  <button type="button" class="btn-light" *ngIf="no.codigo === 'DECISAO_NOMEACAO'" (click)="aplicarDecisaoAssistida({ordem: 1, titulo: 'Nomeação e análise inicial', aba: 'Nomeação', status: 'Em andamento', decisao: no.decisao, perguntas: no.perguntas, proximaAcao: no.proximaAcao, observacaoNbc: no.referencia}, 'sim')">Aceitar</button>
                  <button type="button" class="btn-light" *ngIf="no.codigo === 'DECISAO_NOMEACAO'" (click)="aplicarDecisaoAssistida({ordem: 1, titulo: 'Nomeação e análise inicial', aba: 'Nomeação', status: 'Em andamento', decisao: no.decisao, perguntas: no.perguntas, proximaAcao: no.proximaAcao, observacaoNbc: no.referencia}, 'nao')">Não aceitar</button>
                  <button type="button" class="btn-light" *ngIf="no.codigo === 'DECISAO_HONORARIOS'" (click)="aplicarDecisaoAssistida({ordem: 2, titulo: 'Honorários periciais', aba: 'Honorários', status: 'Em andamento', decisao: no.decisao, perguntas: no.perguntas, proximaAcao: no.proximaAcao, observacaoNbc: no.referencia}, 'sim')">Aprovar/fixar</button>
                  <button type="button" class="btn-light" *ngIf="no.codigo === 'DECISAO_HONORARIOS'" (click)="aplicarDecisaoAssistida({ordem: 2, titulo: 'Honorários periciais', aba: 'Honorários', status: 'Em andamento', decisao: no.decisao, perguntas: no.perguntas, proximaAcao: no.proximaAcao, observacaoNbc: no.referencia}, 'aguardar')">Aguardar</button>
                </div>
              </aside>
            </div>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #fluxoRealTpl>
      <ng-container *ngIf="abaAtiva() === 'Fluxo'; else abasOperacionaisTpl">
        <div class="fluxo-page">
          <div class="section-title">
            <div>
              <h2>Fluxo da Perícia</h2>
              <p>Visão gerencial automática calculada pelas abas operacionais da perícia.</p>
            </div>
          </div>

          <div class="fluxo-resumo">
            <div class="fluxo-kpi">
              <span>Status geral</span>
              <strong>{{ periciaAtual()?.status || 'Não informado' }}</strong>
            </div>
            <div class="fluxo-kpi">
              <span>Etapa atual</span>
              <strong>{{ etapaAtualFluxo()?.nome || '-' }}</strong>
            </div>
            <div class="fluxo-kpi">
              <span>Conclusão geral</span>
              <strong>{{ percentualFluxo() }}%</strong>
            </div>
            <div class="fluxo-kpi">
              <span>Pendências</span>
              <strong>{{ pendenciasFluxo().length }}</strong>
            </div>
          </div>

          <div class="fluxo-progresso">
            <div class="fluxo-progresso-barra">
              <span [style.width.%]="percentualFluxo()"></span>
            </div>
            <p>Próxima ação sugerida: <b>{{ proximaAcaoFluxo() }}</b></p>
          </div>

          <div class="fluxo-trilha">
            <button
              type="button"
              class="fluxo-step"
              *ngFor="let etapa of fluxoEtapas()"
              [ngClass]="classeFluxo(etapa.status)"
              (click)="irParaEtapaFluxo(etapa)">
              <span class="fluxo-ordem">{{ etapa.ordem }}</span>
              <strong>{{ etapa.nome }}</strong>
              <small>{{ etapa.status }}</small>
            </button>
          </div>

          <div class="fluxo-grid">
            <article class="fluxo-card" *ngFor="let etapa of fluxoEtapas()" [ngClass]="classeFluxo(etapa.status)">
              <div class="fluxo-card-top">
                <div>
                  <h3>{{ etapa.nome }}</h3>
                  <span class="status-pill" [ngClass]="classeFluxo(etapa.status)">{{ etapa.status }}</span>
                </div>
                <strong>{{ etapa.percentual }}%</strong>
              </div>

              <div class="fluxo-mini-barra">
                <span [style.width.%]="etapa.percentual"></span>
              </div>

              <p>{{ etapa.resumo }}</p>

              <ul *ngIf="etapa.pendencias.length">
                <li *ngFor="let pendencia of etapa.pendencias">{{ pendencia }}</li>
              </ul>

              <div class="fluxo-card-actions">
                <button type="button" class="btn-mini" (click)="irParaEtapaFluxo(etapa)">Ir para aba</button>
              </div>
            </article>
          </div>

          <div class="fluxo-pendencias">
            <h3>Pendências gerais</h3>
            <div class="vazio" *ngIf="pendenciasFluxo().length === 0">Nenhuma pendência principal encontrada no fluxo.</div>
            <ul *ngIf="pendenciasFluxo().length">
              <li *ngFor="let pendencia of pendenciasFluxo()">{{ pendencia }}</li>
            </ul>
          </div>
        </div>
      </ng-container>
    </ng-template>

      </ng-template>
    <ng-template #abasOperacionaisTpl>
      <ng-container *ngIf="periciaAtual() as pericia; else vazioTpl">
        <ng-container *ngIf="abaAtiva() === 'Equipe'; else calendarioTpl">
          <div class="secao-equipe">
            <div class="section-title">
              <div>
                <h2>Equipe da Perícia</h2>
                <p>Vincule a equipe da perícia. O papel <strong>Perito</strong> é único: só pode existir um perito principal por perícia.</p>
              </div>
              <button type="button" class="btn-primary" (click)="novoVinculoProfissional()">Novo vínculo</button>
            </div>

            <div class="equipe-alerta" *ngIf="peritoPrincipalVinculado() as perito">
              <strong>Perito principal desta perícia:</strong> {{ perito.nome }} — {{ perito.registro || 'registro não informado' }}.
              Para trocar o perito, remova este vínculo e cadastre outro profissional com o papel Perito.
            </div>

            <div class="equipe-form-card" *ngIf="vinculoFormVisivel">
              <div class="form-card-title">Vincular profissional</div>
              <div class="equipe-form-grid">
                <div class="field">
                  <label>Profissional</label>
                  <select [(ngModel)]="vinculoForm.profissional_id">
                    <option [ngValue]="0">Selecione...</option>
                    <option *ngFor="let p of profissionais()" [ngValue]="p.id">{{ p.nome }} - {{ p.tipo }}</option>
                  </select>
                </div>
                <div class="field">
                  <label>Papel na perícia</label>
                  <select [(ngModel)]="vinculoForm.papel">
                    <option *ngFor="let papel of papeisEquipe" [value]="papel" [disabled]="papelEquipeDesabilitado(papel)">{{ papel }}{{ papelEquipeDesabilitado(papel) ? ' — já vinculado' : '' }}</option>
                  </select>
                </div>
                <div class="field">
                  <label>Observações</label>
                  <input [(ngModel)]="vinculoForm.observacoes" placeholder="Ex.: responsável pelos quesitos">
                </div>
                <button type="button" class="btn-light" (click)="cancelarVinculoProfissional()">Cancelar</button>
                <button type="button" class="btn-primary" (click)="vincularProfissional()">Vincular</button>
              </div>
            </div>

            <div class="equipe-table">
              <div class="equipe-head"><div>Nome</div><div>Tipo</div><div>Registro</div><div>E-mail</div><div>Papel</div><div>Ações</div></div>
              <div class="equipe-row" *ngFor="let v of vinculosProfissionais()">
                <div><strong>{{ v.nome }}</strong></div>
                <div>{{ v.tipo }}</div>
                <div>{{ v.registro }}</div>
                <div>{{ v.email }}</div>
                <div><span class="status-pill">{{ v.papel }}</span></div>
                <div><button type="button" class="btn-mini danger" (click)="removerVinculoProfissional(v)">Remover</button></div>
              </div>
              <div class="vazio" *ngIf="vinculosProfissionais().length === 0">Nenhum profissional vinculado a esta perícia.</div>
            </div>
          </div>
        </ng-container>

        <ng-template #calendarioTpl>
          <ng-container *ngIf="abaAtiva() === 'Cronograma'; else planejamentoTpl">
            <div class="secao-cronograma">
              <div class="section-title">
                <div>
                  <h2>Cronograma da Perícia</h2>
                  <p>Visão sequencial por fase, etapa e atividade, separada da aba Programas/Tarefas.</p>
                </div>
              </div>

              <div class="cronograma-card" *ngIf="programasOrdenados().length; else cronogramaVazioTpl">
                <div class="cronograma-legenda">
                  <span class="legenda-item" *ngFor="let item of legendaStatusCronograma()">
                    <span class="legenda-cor" [ngClass]="item.classe"></span>
                    <span>{{ item.rotulo }}</span>
                  </span>
                </div>

                <div class="cronograma-tabela-wrap">
                  <table class="cronograma-tabela cronograma-tabela-aprimorada">
                    <thead>
                      <tr>
                        <th>Fase</th>
                        <th>Etapa</th>
                        <th>Atividade</th>
                        <th>Início</th>
                        <th>Fim</th>
                        <th *ngFor="let coluna of cronogramaColunas()">{{ coluna.rotulo }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let programa of programasOrdenados()">
                        <td class="cronograma-fase">{{ faseCronograma(programa) }}</td>
                        <td class="cronograma-etapa">{{ programa.etapa || '-' }}</td>
                        <td class="cronograma-atividade">
                          <strong>{{ programa.tarefa }}</strong>
                          <small>{{ programa.codigo || ('PRG-' + (programa.ordem || 0)) }}</small>
                        </td>
                        <td class="cronograma-data">{{ dataInicialCronograma(programa) }}</td>
                        <td class="cronograma-data">{{ dataFinalCronograma(programa) }}</td>
                        <td *ngFor="let coluna of cronogramaColunas()" class="cronograma-celula">
                          <div
                            class="cronograma-barra"
                            [ngClass]="classeBarraCronograma(programa.status || '')"
                            *ngIf="programaAtivoNaSemana(programa, coluna.indice)">
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <ng-template #cronogramaVazioTpl>
                <div class="vazio">Nenhum programa/tarefa cadastrado para montar o cronograma.</div>
              </ng-template>
            </div>
          </ng-container>

          <ng-template #planejamentoTpl>
          <ng-container *ngIf="abaAtiva() === 'Planejamento'; else honorariosTpl">
            <div class="secao-planejamento">
              <div class="section-title">
                <div>
                  <h2>Planejamento da Perícia</h2>
                  <p>Define escopo, limites, critérios, riscos, equipe de apoio e produtos finais. Documentos são controlados na aba Documentos e o cronograma fica na aba Cronograma.</p>
                </div>
                <button type="button" class="btn-primary" (click)="salvarPlanejamento()">Salvar planejamento</button>
              </div>

              <div class="planejamento-card">
                <div class="planejamento-grid">
                  <div class="field wide">
                    <label>Objeto da perícia</label>
                    <textarea rows="3" [(ngModel)]="planejamentoForm.objeto_pericia"></textarea>
                  </div>

                  <div class="field">
                    <label>Escopo</label>
                    <textarea rows="4" [(ngModel)]="planejamentoForm.escopo"></textarea>
                  </div>

                  <div class="field">
                    <label>Limites</label>
                    <textarea rows="4" [(ngModel)]="planejamentoForm.limites"></textarea>
                  </div>

                  <div class="field">
                    <label>Critérios técnicos</label>
                    <textarea rows="4" [(ngModel)]="planejamentoForm.criterios_tecnicos"></textarea>
                  </div>
<div class="field">
                    <label>Riscos e limitações</label>
                    <textarea rows="4" [(ngModel)]="planejamentoForm.riscos_limitacoes"></textarea>
                  </div>
<div class="field">
                    <label>Equipe de apoio</label>
                    <textarea rows="3" [(ngModel)]="planejamentoForm.equipe_apoio"></textarea>
                  </div>

                  <div class="field">
                    <label>Produtos finais</label>
                    <textarea rows="3" [(ngModel)]="planejamentoForm.produtos_finais"></textarea>
                  </div>

                  <div class="field">
                    <label>Status</label>
                    <select [(ngModel)]="planejamentoForm.status">
                      <option *ngFor="let s of statusPlanejamento" [value]="s">{{ s }}</option>
                    </select>
                  </div>

                  <div class="field">
                    <label>Data conclusão</label>
                    <input type="date" [(ngModel)]="planejamentoForm.data_conclusao">
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>
        </ng-template>

        <ng-template #honorariosTpl>
          <ng-container *ngIf="abaAtiva() === 'Honorários'; else programasTpl">
            <div class="secao-honorarios secao-honorarios-v914">
              <div class="section-title">
                <div>
                  <h2>Honorários e Propostas</h2>
                  <p>A proposta usa automaticamente os dados do cadastro da perícia e a estimativa por blocos.</p>
                </div>
              </div>

              <div class="honorarios-toolbar-v9144">
                <div class="toolbar-info">
                  <strong>Proposta de honorários</strong>
                  <small>Os modelos ficam salvos no sistema. Os dados do cadastro entram automaticamente na proposta.</small>
                </div>
                <div class="toolbar-actions">
                  <button type="button" class="btn-action secondary" (click)="salvarHonorariosV914()" [disabled]="salvandoHonorarios"><span>💾</span><b>Salvar</b><small>gravar estimativa</small></button>
                  <button type="button" class="btn-action primary" (click)="visualizarPreviewHonorarios('juizo')" [disabled]="salvandoHonorarios"><span>⚖️</span><b>Prévia Juízo</b><small>modelo judicial</small></button>
                  <button type="button" class="btn-action primary" (click)="visualizarPreviewHonorarios('assistente')" [disabled]="salvandoHonorarios"><span>🤝</span><b>Prévia Assistente</b><small>parte/advogado</small></button>
                  <button type="button" class="btn-action primary" (click)="visualizarPreviewHonorarios('extrajudicial')" [disabled]="salvandoHonorarios"><span>📑</span><b>Prévia Extrajudicial</b><small>cliente privado</small></button>
                </div>
              </div>

              <div class="honorarios-parametros-card honorarios-parametros-card-v914 honorarios-parametros-card-v9144">
                <div class="field">
                  <label>Modelo de estimativa</label>
                  <select [(ngModel)]="honorariosForm.modelo_estimativa">
                    <option *ngFor="let modelo of modelosEstimativaHonorarios" [value]="modelo">{{ modelo }}</option>
                  </select>
                </div>
                <div class="field">
                  <label>Complexidade</label>
                  <select [(ngModel)]="honorariosForm.complexidade">
                    <option *ngFor="let c of complexidadesHonorarios" [value]="c">{{ c }}</option>
                  </select>
                </div>
                <div class="field"><label>Prazo estimado</label><input [(ngModel)]="honorariosForm.prazo_estimado" placeholder="Ex.: 20 dias úteis"></div>
                <div class="field"><label>Valor/hora padrão</label><input type="number" min="0" [(ngModel)]="honorariosForm.valor_hora_padrao"><small>Usado como referência dos blocos, não das tarefas.</small></div>
                <div class="field"><label>Valor da ação</label><input type="number" min="0" [(ngModel)]="honorariosForm.valor_acao"></div>
                <div class="field"><label>% sobre valor da ação</label><input type="number" min="0" step="0.01" [(ngModel)]="honorariosForm.percentual_valor_acao"></div>
                <div class="field"><label>Valor fixo</label><input type="number" min="0" [(ngModel)]="honorariosForm.valor_fixo"></div>
                <div class="field"><label>Despesas estimadas</label><input type="number" min="0" [(ngModel)]="honorariosForm.despesas_estimadas"></div>
                <div class="field"><label>Status dos honorários</label><select [(ngModel)]="honorariosForm.status_honorarios"><option *ngFor="let s of statusHonorariosJudicial" [value]="s">{{ s }}</option></select><small>Somente aprovado/fixado ou depósito libera Planejamento, Execução e Laudo.</small></div>
                <div class="field"><label>Data da proposta</label><input type="date" [(ngModel)]="honorariosForm.data_proposta"></div>
                <div class="field"><label>Valor proposto pelo perito</label><input [value]="totalFinalHonorariosForm() | currency:'BRL':'symbol':'1.2-2'" disabled><small>Calculado automaticamente pela estimativa.</small></div>
                <div class="field"><label>Valor fixado pelo juiz</label><input type="number" min="0" [(ngModel)]="honorariosForm.valor_fixado_juiz"><small>Preencha se o juiz alterar/fixar valor diferente.</small></div>
                <div class="field"><label>Data da decisão/fixação</label><input type="date" [(ngModel)]="honorariosForm.data_decisao"></div>
                <div class="field system-field"><label>Tipo de proposta</label><input [value]="tipoAtuacaoSistemaHonorarios()" disabled><small>Definido automaticamente conforme o preview escolhido.</small></div>
              </div>

              <div class="honorarios-resumo honorarios-resumo-v914">
                <div><span>Critério utilizado</span><strong>{{ criterioHonorariosV914() }}</strong></div>
                <div><span>Total por blocos</span><strong>{{ totalBlocosHonorariosForm() | currency:'BRL':'symbol':'1.2-2' }}</strong></div>
                <div><span>Total por percentual</span><strong>{{ totalPercentualHonorariosForm() | currency:'BRL':'symbol':'1.2-2' }}</strong></div>
                <div><span>Valor fixo</span><strong>{{ honorariosForm.valor_fixo || 0 | currency:'BRL':'symbol':'1.2-2' }}</strong></div>
                <div><span>Despesas</span><strong>{{ honorariosForm.despesas_estimadas || 0 | currency:'BRL':'symbol':'1.2-2' }}</strong></div>
                <div><span>Total sugerido</span><strong>{{ totalFinalHonorariosForm() | currency:'BRL':'symbol':'1.2-2' }}</strong></div>
                <div><span>Status judicial</span><strong>{{ honorariosForm.status_honorarios }}</strong></div>
                <div><span>Valor fixado</span><strong>{{ honorariosForm.valor_fixado_juiz || 0 | currency:'BRL':'symbol':'1.2-2' }}</strong></div>
                <div><span>Valor considerado</span><strong>{{ valorConsideradoHonorarios() | currency:'BRL':'symbol':'1.2-2' }}</strong></div>
              </div>

              <div class="honorarios-blocos-card">
                <div class="section-title compact">
                  <div><h3>Blocos de trabalho</h3><p>Estimativa por blocos maiores para evitar prolongar o cálculo em cada tarefa operacional.</p></div>
                  <div class="quesito-actions">
                    <button type="button" class="btn-light" (click)="restaurarBlocosPadraoHonorarios()">Restaurar blocos padrão</button>
                    <button type="button" class="btn-light" (click)="aplicarValorHoraPadraoNosBlocos()">Aplicar valor/hora nos blocos</button>
                    <button type="button" class="btn-primary" (click)="adicionarBlocoHonorarios()">Adicionar bloco</button>
                  </div>
                </div>
                <div class="honorarios-blocos-head"><div>Bloco</div><div>Descrição</div><div>Horas</div><div>Valor/hora</div><div>Total</div><div>Complexidade</div><div>Ações</div></div>
                <div class="honorarios-blocos-row" *ngFor="let bloco of honorariosForm.blocos; let i = index">
                  <div><input [(ngModel)]="bloco.bloco"></div><div><textarea rows="2" [(ngModel)]="bloco.descricao"></textarea></div><div><input type="number" min="0" [(ngModel)]="bloco.horas_estimadas"></div><div><input type="number" min="0" [(ngModel)]="bloco.valor_hora"></div><div><strong>{{ valorBlocoHonorarios(bloco) | currency:'BRL':'symbol':'1.2-2' }}</strong></div>
                  <div><select [(ngModel)]="bloco.complexidade"><option *ngFor="let c of complexidadesHonorarios" [value]="c">{{ c }}</option></select></div>
                  <div><button type="button" class="btn-mini danger" (click)="removerBlocoHonorarios(i)">Remover</button></div>
                  <div class="honorarios-observacao"><input [(ngModel)]="bloco.observacao" placeholder="Observação do bloco"></div>
                </div>
              </div>

              <div class="honorarios-preview-modal" *ngIf="visualizandoPreviewHonorarios">
                <div class="preview-backdrop" (click)="fecharPreviewHonorarios()"></div>
                <div class="preview-window">
                  <div class="preview-window-header"><div><strong>{{ previewHonorariosTitulo }}</strong><small>Confira a proposta em janela. Se estiver correta, exporte em PDF, Word ou HTML diretamente por aqui.</small></div><button type="button" class="btn-close-preview" (click)="fecharPreviewHonorarios()">×</button></div>
                  <div class="preview-window-actions"><label>Formato</label><select [(ngModel)]="formatoExportacaoHonorariosSelecionado"><option value="pdf">PDF</option><option value="docx">Word (.docx)</option><option value="html">HTML</option></select><button type="button" class="btn-primary" (click)="exportarHonorariosSelecionado()" [disabled]="salvandoHonorarios">Exportar proposta</button><button type="button" class="btn-light" (click)="fecharPreviewHonorarios()">Fechar e voltar</button></div>
                  <iframe class="honorarios-preview-frame-modal" [srcdoc]="previewHonorariosHtml"></iframe>
                </div>
              </div>

              <div class="honorarios-orientacao-card">
                <strong>Importante</strong>
                <p>Os dados de processo, cliente/parte, vara/câmara, tipo e objeto são puxados do cadastro da perícia. Aqui você ajusta somente valores, blocos, prazo e observações da proposta.</p>
                <textarea rows="3" [(ngModel)]="honorariosForm.observacoes" placeholder="Observações para a proposta, ressalvas de escopo ou condições de pagamento"></textarea>
                <label class="mt-label">Observações da decisão/fixação dos honorários</label>
                <textarea rows="3" [(ngModel)]="honorariosForm.observacoes_decisao" placeholder="Ex.: Juízo fixou valor inferior, determinou depósito, houve impugnação das partes etc."></textarea>
              </div>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #programasTpl>
          <ng-container *ngIf="abaAtiva() === 'Programas/Tarefas'; else quesitosTpl">
            <div class="secao-programas">
              <div class="section-title">
                <div>
                  <h2>Programas/Tarefas de Trabalho</h2>
                  <p>Aqui ficam apenas a lista de programas/tarefas cadastradas e a inclusão manual de novas tarefas. O cronograma fica em aba própria.</p>
                </div>
                <button type="button" class="btn-primary" (click)="novoPrograma()">Nova tarefa</button>
              </div>

              
              <div class="tarefas-modelo-card">
                <div class="tarefas-modelo-resumo">
                  <div>
                    <h3>Modelo padrão aplicado</h3>
                    <p>As tarefas comuns são incluídas automaticamente. As tarefas específicas do tipo de perícia podem ser adicionadas quando desejar.</p>
                  </div>
                  <div class="tarefas-modelo-kpis">
                    <span>Comuns: {{ tarefasPadraoComuns().length }}</span>
                    <span>Específicas do tipo: {{ tarefasPadraoEspecificas().length }}</span>
                    <span>Já cadastradas: {{ programas().length }}</span>
                  </div>
                </div>

                <div class="tarefas-modelo-acoes">
                  <button type="button" class="btn-primary" (click)="adicionarTarefasPadraoPendentes()">Adicionar tarefas específicas padrão</button>
                  <button type="button" class="btn-light" (click)="novoPrograma()">Incluir outra tarefa manualmente</button>
                </div>
              </div>

<div class="programa-form-card programa-form-card-v2" *ngIf="programaFormVisivel">
                <div class="form-card-title">{{ programaEditandoId ? 'Editar tarefa/programa de trabalho' : 'Nova tarefa/programa de trabalho' }}</div>

                <div class="programa-layout-v2">
                  <div class="programa-linha programa-linha-identificacao">
                    <div class="field ordem-programa">
                      <label>Código</label>
                      <input [ngModel]="programaEditandoId ? (programaForm.codigo || codigoPreviewPrograma()) : codigoPreviewPrograma()" readonly class="input-readonly">
                      <small>{{ programaEditandoId ? 'Código do programa/tarefa.' : 'Gerado automaticamente ao cadastrar: PRG-001, PRG-002...' }}</small>
                    </div>

                    <div class="field etapa-programa">
                      <label>Etapa</label>
                      <select [(ngModel)]="programaForm.etapa">
                        <option *ngFor="let etapa of etapasPrograma" [value]="etapa">{{ etapa }}</option>
                      </select>
                    </div>

                    <div class="field tarefa-programa">
                      <label>Tarefa</label>
                      <input [(ngModel)]="programaForm.tarefa" placeholder="Ex.: Conferir extratos bancários">
                    </div>

                    <div class="field procedimento-programa">
                      <label>Procedimento</label>
                      <select [(ngModel)]="programaForm.procedimento">
                        <option *ngFor="let procedimento of procedimentosPrograma" [value]="procedimento">{{ procedimento }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="programa-linha programa-linha-controle">
                    <div class="field">
                      <label>Documento necessário</label>
                      <input [(ngModel)]="programaForm.documento_necessario">
                    </div>

                    <div class="field">
                      <label>Responsável</label>
                      <input [(ngModel)]="programaForm.responsavel">
                    </div>

                    <div class="field">
                      <label>Data prevista</label>
                      <input type="date" [(ngModel)]="programaForm.data_prevista">
                    </div>

                    <div class="field">
                      <label>Data conclusão</label>
                      <input type="date" [(ngModel)]="programaForm.data_conclusao">
                    </div>

                    <div class="field">
                      <label>Status</label>
                      <select [(ngModel)]="programaForm.status">
                        <option *ngFor="let status of statusTarefa" [value]="status">{{ status }}</option>
                      </select>
                    </div>

                  </div>

                  <div class="programa-linha programa-linha-textos">
                    <div class="field">
                      <label>Descrição</label>
                      <textarea rows="4" [(ngModel)]="programaForm.descricao"></textarea>
                    </div>

                    <div class="field">
                      <label>Resultado</label>
                      <textarea rows="4" [(ngModel)]="programaForm.resultado"></textarea>
                    </div>

                    <div class="field">
                      <label>Observações</label>
                      <textarea rows="4" [(ngModel)]="programaForm.observacoes"></textarea>
                    </div>
                  </div>
                </div>

                <div class="quesito-actions">
                  <button type="button" class="btn-light" (click)="cancelarPrograma()">Cancelar</button>
                  <button type="button" class="btn-primary" (click)="salvarPrograma()">
                    {{ programaEditandoId ? 'Salvar alteração' : 'Cadastrar tarefa' }}
                  </button>
                </div>
              </div>

              <div class="programas-table">
                <div class="programas-head">
                  <div>Código</div><div>Etapa</div><div>Tarefa</div><div>Responsável</div><div>Data prevista</div><div>Status</div><div>Ações</div>
                </div>
                <div class="programas-row" *ngFor="let p of programas()">
                  <div><strong>{{ p.codigo || ('PRG-' + (p.ordem || 0)) }}</strong></div>
                  <div>{{ p.etapa }}</div>
                  <div>{{ p.tarefa }}</div>
                  <div>{{ p.responsavel || '-' }}</div>
                  <div>{{ p.data_prevista || '-' }}</div>
                  <div><span class="status-pill" [ngClass]="classeStatus(p.status)">{{ p.status }}</span></div>
                  <div class="row-actions">
                    <button type="button" class="btn-mini" (click)="editarPrograma(p)">Editar</button>
                    <button type="button" class="btn-mini danger" (click)="excluirPrograma(p)">Excluir</button>
                  </div>
                </div>
                <div class="vazio" *ngIf="programas().length === 0">Nenhuma tarefa/programa cadastrada para esta perícia.</div>
              </div>
            </div>
          </ng-container>
        </ng-template>

        <ng-template #quesitosTpl>
        <ng-container *ngIf="abaAtiva() === 'Documentos'; else diligenciasTpl">
          <div class="secao-documentos">
            <div class="section-title">
              <div>
                <h2>Documentos</h2>
                <p>Controle de documentos vinculados à perícia selecionada.</p>
              </div>
              <button type="button" class="btn-primary" (click)="novoDocumento()">Novo documento</button>
            </div>


            <div class="docs-padrao-card" *ngIf="documentosPadraoDaPericia().length">
              <div class="docs-padrao-top">
                <div>
                  <h3>Documentos necessários para {{ formulario.tipo_pericia || periciaAtual()?.tipo_pericia }}</h3>
                  <p>Lista padrão conforme o tipo de perícia. Adicione os pendentes e depois controle recebimento/validação na grade de documentos.</p>
                </div>
                <button type="button" class="btn-primary" (click)="adicionarDocumentosPadraoPendentes()">Adicionar pendentes</button>
              </div>

              <div class="docs-padrao-lista">
                <div class="docs-padrao-row" *ngFor="let doc of documentosPadraoDaPericia()">
                  <div>
                    <strong>{{ doc.descricao }}</strong>
                    <span>{{ doc.tipo_documento }} • {{ doc.formato }} • {{ doc.obrigatorio ? 'Obrigatório' : 'Recomendado' }}</span>
                  </div>
                  <span class="status-pill" [ngClass]="classeStatus(statusDocumentoPadrao(doc))">{{ statusDocumentoPadrao(doc) }}</span>
                  <button type="button" class="btn-mini" *ngIf="!documentoPadraoExiste(doc)" (click)="adicionarDocumentoPadrao(doc)">Adicionar</button>
                  <button type="button" class="btn-mini" disabled *ngIf="documentoPadraoExiste(doc)">Incluído</button>
                </div>
              </div>
            </div>

            <div class="documento-form-card" *ngIf="documentoFormVisivel">
              <div class="form-card-title">{{ documentoEditandoId ? 'Editar documento' : 'Novo documento' }}</div>

              <div class="documento-layout-regular">
                <div class="documento-linha documento-linha-identificacao">
                  <div class="field">
            <label>Código</label>
            <input [ngModel]="documentoEditandoId ? documentoForm.codigo : codigoPreviewItem('DOC')" readonly class="input-readonly">
            <small>{{ documentoEditandoId ? 'Código do documento.' : 'Gerado automaticamente ao cadastrar.' }}</small>
          </div>

                  <div class="field">
                    <label>Tipo documento</label>
                    <select [(ngModel)]="documentoForm.tipo_documento">
                      <option *ngFor="let tipo of tiposDocumento" [value]="tipo">{{ tipo }}</option>
                    </select>
                  </div>

                  <div class="field">
                    <label>Fornecedor</label>
                    <input [(ngModel)]="documentoForm.fornecedor" placeholder="Banco, parte, contador etc.">
                  </div>

                  <div class="field">
                    <label>Status</label>
                    <select [(ngModel)]="documentoForm.status">
                      <option *ngFor="let status of statusDocumento" [value]="status">{{ status }}</option>
                    </select>
                  </div>
                </div>

                <div class="documento-linha documento-linha-arquivo">
                  <div class="field">
                    <label>Data recebimento</label>
                    <input type="date" [(ngModel)]="documentoForm.data_recebimento">
                  </div>

                  <div class="field">
                    <label>Formato</label>
                    <select [(ngModel)]="documentoForm.formato">
                      <option *ngFor="let formato of formatosDocumento" [value]="formato">{{ formato }}</option>
                    </select>
                  </div>

                  <div class="field">
                    <label>Arquivo físico</label>
                    <input type="file" (change)="selecionarArquivoDocumento($event)">
                    <small>Opcional: se selecionar, o arquivo será enviado automaticamente ao cadastrar.</small>
                  </div>

                  <div class="field">
                    <label>&nbsp;</label>
                    <button type="button" class="btn-light full-btn" (click)="enviarArquivoDocumento()">Enviar agora</button>
                  </div>
                </div>

                <div class="documento-info-arquivo" *ngIf="documentoForm.caminho_arquivo || documentoForm.hash_sha256">
                  <div>
                    <strong>Arquivo vinculado:</strong>
                    <span>{{ documentoForm.caminho_arquivo || 'Aguardando upload' }}</span>
                  </div>
                  <div>
                    <strong>Hash SHA256:</strong>
                    <span>{{ documentoForm.hash_sha256 || '-' }}</span>
                  </div>
                </div>

                <div class="documento-linha documento-linha-textos">
                  <div class="field">
                    <label>Descrição</label>
                    <textarea rows="4" [(ngModel)]="documentoForm.descricao"></textarea>
                  </div>

                  <div class="field">
                    <label>Observações</label>
                    <textarea rows="4" [(ngModel)]="documentoForm.observacoes"></textarea>
                  </div>
                </div>
              </div>

              <div class="quesito-actions">
                <button type="button" class="btn-light" (click)="cancelarDocumento()">Cancelar</button>
                <button type="button" class="btn-primary" (click)="salvarDocumento()">
                  {{ documentoEditandoId ? 'Salvar alteração' : 'Cadastrar documento' }}
                </button>
              </div>
            </div>

            <div class="documentos-table">
              <div class="documentos-head">
                <div>Código</div><div>Tipo</div><div>Descrição</div><div>Fornecedor</div><div>Recebimento</div><div>Formato</div><div>Status</div><div>Ações</div>
              </div>
              <div class="documentos-row" *ngFor="let d of documentosPericia()">
                <div><strong>{{ d.codigo }}</strong></div>
                <div>{{ d.tipo_documento }}</div>
                <div>{{ d.descricao }}</div>
                <div>{{ d.fornecedor }}</div>
                <div>{{ d.data_recebimento || '-' }}</div>
                <div>{{ d.formato }}</div>
                <div><span class="status-pill" [ngClass]="classeStatus(d.status)">{{ d.status }}</span></div>
                <div class="row-actions">
                  <button type="button" class="btn-mini" (click)="editarDocumento(d)">Editar</button>
                  <button type="button" class="btn-mini" (click)="baixarDocumento(d)">Abrir/Baixar</button>
                  <button type="button" class="btn-mini danger" (click)="excluirDocumento(d)">Excluir</button>
                </div>
              </div>
              <div class="vazio" *ngIf="documentosPericia().length === 0">Nenhum documento cadastrado para esta perícia.</div>
            </div>
          </div>
        </ng-container>
        </ng-template>

        <ng-template #diligenciasTpl>
        <ng-container *ngIf="abaAtiva() === 'Diligências'; else quesitosReaisTpl">
          <div class="secao-diligencias">
            <div class="section-title">
              <div>
                <h2>Diligências</h2>
                <p>Controle de solicitações, prazos e respostas recebidas.</p>
              </div>
              <button type="button" class="btn-primary" (click)="novaDiligencia()">Nova diligência</button>
            </div>

            <div class="diligencia-form-card" *ngIf="diligenciaFormVisivel">
              <div class="form-card-title">{{ diligenciaEditandoId ? 'Editar diligência' : 'Nova diligência' }}</div>

              <div class="diligencia-layout-regular">
                <div class="diligencia-linha diligencia-linha-identificacao">
                  <div class="field">
            <label>Código</label>
            <input [ngModel]="diligenciaEditandoId ? diligenciaForm.codigo : codigoPreviewItem('DLG')" readonly class="input-readonly">
            <small>{{ diligenciaEditandoId ? 'Código da diligência.' : 'Gerado automaticamente ao cadastrar.' }}</small>
          </div>

                  <div class="field">
                    <label>Data envio</label>
                    <input type="date" [(ngModel)]="diligenciaForm.data_envio">
                  </div>

                  <div class="field destinatario">
                    <label>Destinatário</label>
                    <input [(ngModel)]="diligenciaForm.destinatario" placeholder="Banco, parte, contador etc.">
                  </div>

                  <div class="field">
                    <label>Status</label>
                    <select [(ngModel)]="diligenciaForm.status">
                      <option *ngFor="let status of statusDiligencia" [value]="status">{{ status }}</option>
                    </select>
                  </div>
                </div>

                <div class="diligencia-linha diligencia-linha-prazos">
                  <div class="field">
                    <label>Prazo resposta</label>
                    <input type="date" [(ngModel)]="diligenciaForm.prazo_resposta">
                  </div>

                  <div class="field">
                    <label>Data resposta</label>
                    <input type="date" [(ngModel)]="diligenciaForm.data_resposta">
                  </div>
                </div>

                <div class="diligencia-linha diligencia-linha-solicitacao">
                  <div class="field">
                    <label>Solicitação</label>
                    <textarea rows="4" [(ngModel)]="diligenciaForm.solicitacao"></textarea>
                  </div>
                </div>

                <div class="diligencia-linha diligencia-linha-textos">
                  <div class="field">
                    <label>Resposta recebida</label>
                    <textarea rows="4" [(ngModel)]="diligenciaForm.resposta_recebida"></textarea>
                  </div>

                  <div class="field">
                    <label>Observações</label>
                    <textarea rows="4" [(ngModel)]="diligenciaForm.observacoes"></textarea>
                  </div>
                </div>
              </div>

              <div class="quesito-actions">
                <button type="button" class="btn-light" (click)="cancelarDiligencia()">Cancelar</button>
                <button type="button" class="btn-primary" (click)="salvarDiligencia()">
                  {{ diligenciaEditandoId ? 'Salvar alteração' : 'Cadastrar diligência' }}
                </button>
              </div>
            </div>

            <div class="diligencias-table">
              <div class="diligencias-head">
                <div>Código</div><div>Envio</div><div>Destinatário</div><div>Solicitação</div><div>Prazo</div><div>Status</div><div>Resposta</div><div>Ações</div>
              </div>
              <div class="diligencias-row" *ngFor="let d of diligenciasPericia()">
                <div><strong>{{ d.codigo }}</strong></div>
                <div>{{ d.data_envio || '-' }}</div>
                <div>{{ d.destinatario }}</div>
                <div>{{ d.solicitacao }}</div>
                <div>{{ d.prazo_resposta || '-' }}</div>
                <div><span class="status-pill" [ngClass]="classeStatus(d.status)">{{ d.status }}</span></div>
                <div>{{ d.resposta_recebida || '-' }}</div>
                <div class="row-actions">
                  <button type="button" class="btn-mini" (click)="editarDiligencia(d)">Editar</button>
                  <button type="button" class="btn-mini danger" (click)="excluirDiligencia(d)">Excluir</button>
                </div>
              </div>
              <div class="vazio" *ngIf="diligenciasPericia().length === 0">Nenhuma diligência cadastrada para esta perícia.</div>
            </div>
          </div>
        </ng-container>
        </ng-template>

        <ng-template #quesitosReaisTpl>
        <ng-container *ngIf="abaAtiva() === 'Quesitos'; else outrasAbasTpl">
          <div class="secao-quesitos">
            <div class="section-title">
              <div>
                <h2>Quesitos</h2>
                <p>Quesitos vinculados à perícia selecionada: {{ pericia.codigo }} - {{ pericia.titulo }}</p>
              </div>
              <button type="button" class="btn-primary" (click)="novoQuesito()">Novo quesito</button>
            </div>

            <div class="selecione-uma-pericia" *ngIf="!periciaSelecionadaId && modo() !== 'novo' && !mostrarListaPericias">
    Selecione uma perícia na lista acima ou clique em <b>Nova perícia</b>.
  </div>

  <div class="alerts">
              <div class="alert erro" *ngIf="erroQuesitos()">{{ erroQuesitos() }}</div>
              <div class="alert ok" *ngIf="mensagemQuesitos()">{{ mensagemQuesitos() }}</div>
            </div>

            <div class="quesito-form-card" *ngIf="quesitoFormVisivel">
              <div class="form-card-title">{{ quesitoEditandoId ? 'Editar quesito' : 'Novo quesito' }}</div>

              <div class="quesito-layout">
                <div class="quesito-meta">
                  <div class="field numero-quesito">
                    <label>Código</label>
                    <input [ngModel]="quesitoEditandoId ? (quesitoForm.codigo || codigoPreviewItem('QTO')) : codigoPreviewItem('QTO')" readonly class="input-readonly">
                    <small>{{ quesitoEditandoId ? 'Código do quesito.' : 'Gerado automaticamente ao cadastrar.' }}</small>
                  </div>

                  <div class="field origem-quesito">
                    <label>Origem</label>
                    <select [(ngModel)]="quesitoForm.origem">
                      <option *ngFor="let origem of origensQuesito" [value]="origem">{{ origem }}</option>
                    </select>
                  </div>

                  <div class="field status-quesito">
                    <label>Status</label>
                    <select [(ngModel)]="quesitoForm.status">
                      <option *ngFor="let status of statusQuesito" [value]="status">{{ status }}</option>
                    </select>
                  </div>
                </div>

                <div class="quesito-textos">
                  <div class="field texto-quesito">
                    <label>Texto do quesito</label>
                    <textarea rows="5" [(ngModel)]="quesitoForm.texto" placeholder="Digite o quesito apresentado"></textarea>
                  </div>

                  <div class="field resposta-quesito">
                    <label>Resposta / resumo</label>
                    <textarea rows="5" [(ngModel)]="quesitoForm.resposta_resumo" placeholder="Resumo da resposta técnica ou encaminhamento"></textarea>
                  </div>
                </div>

                <div class="quesito-actions">
                  <button type="button" class="btn-light" (click)="limparFormularioQuesito()">Cancelar</button>
                  <button type="button" class="btn-primary" (click)="salvarQuesito()">
                    {{ quesitoEditandoId ? 'Salvar alteração' : 'Cadastrar quesito' }}
                  </button>
                </div>
              </div>
            </div>

            <div class="quesitos-table-card">
              <div class="lista-header">
                <h3>Quesitos cadastrados</h3>
                <span>{{ quesitos().length }} registro(s)</span>
              </div>

              <div class="vazio" *ngIf="carregandoQuesitos()">Carregando quesitos...</div>

              <div class="quesitos-table" *ngIf="!carregandoQuesitos() && quesitos().length; else semQuesitosTpl">
                <div class="quesitos-head">
                  <div>Código</div>
                  <div>Origem</div>
                  <div>Texto</div>
                  <div>Status</div>
                  <div>Resposta / resumo</div>
                  <div>Ações</div>
                </div>

                <div class="quesitos-row" *ngFor="let q of quesitos()">
                  <div><strong>{{ q.codigo || ('QTO-' + (q.numero || 0)) }}</strong></div>
                  <div>{{ q.origem }}</div>
                  <div>{{ q.texto }}</div>
                  <div><span class="status-pill" [ngClass]="classeStatus(q.status)">{{ q.status }}</span></div>
                  <div>{{ q.resposta_resumo }}</div>
                  <div class="row-actions">
                    <button type="button" class="btn-mini" (click)="editarQuesito(q)">Editar</button>
                    <button type="button" class="btn-mini danger" (click)="excluirQuesito(q)">Excluir</button>
                  </div>
                </div>
              </div>

              <ng-template #semQuesitosTpl>
                <div class="vazio" *ngIf="!carregandoQuesitos()">Nenhum quesito cadastrado para esta perícia.</div>
              </ng-template>
            </div>
          </div>
        </ng-container>
        </ng-template>

        <ng-template #outrasAbasTpl>
  <ng-container *ngIf="abaAtiva() === 'Execuções'; else achadosAnaliticosTpl">
    <div class="secao-registros secao-analitica">
      <div class="section-title">
        <div>
          <h2>Execuções analíticas</h2>
          <p>Registros de execução vinculados à perícia selecionada: {{ pericia.codigo }} - {{ pericia.titulo }}</p>
        </div>
        <button type="button" class="btn-primary" (click)="novaExecucaoAnalitica()">Novo item</button>
      </div>

      <div class="analitico-form-card" *ngIf="execucaoFormVisivel">
        <div class="form-card-title">Nova execução analítica</div>

        <div class="analitico-grid">
          <div class="field">
            <label>Rotina analítica</label>
            <select [(ngModel)]="execucaoForm.rotina_id">
              <option [ngValue]="null">Selecione</option>
              <option *ngFor="let rotina of rotinasAnaliticas()" [ngValue]="rotina.id">
                {{ rotina.nome || ('Rotina ' + rotina.id) }}{{ rotina.tipo ? ' - ' + rotina.tipo : '' }}
              </option>
            </select>
            <small *ngIf="rotinasAnaliticas().length === 0">Cadastre pelo menos uma rotina em pericia.rotinas_analiticas.</small>
          </div>

          <div class="field">
            <label>Status</label>
            <select [(ngModel)]="execucaoForm.status">
              <option *ngFor="let status of statusExecucaoAnalitica" [value]="status">{{ status }}</option>
            </select>
          </div>

          <div class="field">
            <label>Total registros</label>
            <input type="number" [(ngModel)]="execucaoForm.total_registros">
          </div>

          <div class="field">
            <label>Total achados</label>
            <input type="number" [(ngModel)]="execucaoForm.total_achados">
          </div>

          <div class="field full">
            <label>Parâmetros JSON</label>
            <textarea rows="3" [(ngModel)]="execucaoForm.parametros_json" placeholder='{"competencia":"2026-01"}'></textarea>
          </div>

          <div class="field full">
            <label>Resumo JSON</label>
            <textarea rows="3" [(ngModel)]="execucaoForm.resumo_json" placeholder='{"resultado":"ok"}'></textarea>
          </div>

          <div class="field full">
            <label>Texto técnico</label>
            <textarea rows="4" [(ngModel)]="execucaoForm.texto_tecnico"></textarea>
          </div>

          <div class="field full">
            <label>Arquivo entrada principal</label>
            <input [(ngModel)]="execucaoForm.arquivo_entrada_principal">
          </div>

          <div class="field">
            <label>Arquivo saída resumo</label>
            <input [(ngModel)]="execucaoForm.arquivo_saida_resumo">
          </div>

          <div class="field">
            <label>Arquivo saída achados</label>
            <input [(ngModel)]="execucaoForm.arquivo_saida_achados">
          </div>

          <div class="field full">
            <label>Log execução</label>
            <textarea rows="3" [(ngModel)]="execucaoForm.log_execucao"></textarea>
          </div>
        </div>

        <div class="quesito-actions">
          <button type="button" class="btn-light" (click)="execucaoFormVisivel = false">Cancelar</button>
          <button type="button" class="btn-primary" (click)="salvarExecucaoAnalitica()">Salvar execução</button>
        </div>
      </div>

      <div class="analitico-table">
        <div class="analitico-head execucoes-head">
          <div>ID</div><div>Código</div><div>Rotina</div><div>Status</div><div>Registros</div><div>Achados</div><div>Texto técnico</div><div>Criado em</div><div>Ações</div>
        </div>

        <div class="analitico-row execucoes-row" *ngFor="let e of execucoesAnaliticas()">
          <div><strong>{{ e.id }}</strong></div>
          <div><strong>{{ e.codigo || '-' }}</strong></div>
          <div>{{ e.rotina_nome || ('Rotina ' + e.rotina_id) }}</div>
          <div><span class="status-pill" [ngClass]="classeStatus(e.status)">{{ e.status }}</span></div>
          <div>{{ e.total_registros || 0 }}</div>
          <div>{{ e.total_achados || 0 }}</div>
          <div>{{ e.texto_tecnico || '-' }}</div>
          <div>{{ e.created_at || '-' }}</div>
          <div class="row-actions">
            <button type="button" class="btn-mini danger" (click)="excluirExecucaoAnalitica(e)">Excluir</button>
          </div>
        </div>

        <div class="vazio" *ngIf="execucoesAnaliticas().length === 0">Nenhuma execução analítica cadastrada para esta perícia.</div>
      </div>
    </div>
  </ng-container>

  <ng-template #achadosAnaliticosTpl>
  <ng-container *ngIf="abaAtiva() === 'Achados'; else evidenciasAnaliticasTpl">
    <div class="secao-registros secao-analitica">
      <div class="section-title">
        <div>
          <h2>Achados analíticos</h2>
          <p>Achados vinculados às execuções analíticas da perícia selecionada.</p>
        </div>
        <button type="button" class="btn-primary" (click)="novoAchadoAnalitico()">Novo item</button>
      </div>

      <div class="analitico-form-card" *ngIf="achadoFormVisivel">
        <div class="form-card-title">Novo achado analítico</div>

        <div class="analitico-grid">
          <div class="field">
            <label>Execução vinculada</label>
            <select [(ngModel)]="achadoAnaliticoForm.execucao_id">
              <option [ngValue]="null">Selecione</option>
              <option *ngFor="let execucao of execucoesAnaliticas()" [ngValue]="execucao.id">Execução {{ execucao.id }} - {{ execucao.status }}</option>
            </select>
          </div>

          <div class="field">
            <label>Tipo do achado</label>
            <select [(ngModel)]="achadoAnaliticoForm.tipo_achado">
              <option *ngFor="let tipo of tiposAchadoAnalitico" [value]="tipo">{{ tipo }}</option>
            </select>
          </div>

          <div class="field">
            <label>Gravidade</label>
            <select [(ngModel)]="achadoAnaliticoForm.gravidade">
              <option *ngFor="let gravidade of gravidadesAchado" [value]="gravidade">{{ gravidade }}</option>
            </select>
          </div>

          <div class="field">
            <label>Valor relacionado</label>
            <input [(ngModel)]="achadoAnaliticoForm.valor_relacionado">
          </div>

          <div class="field">
            <label>Linha origem</label>
            <input [(ngModel)]="achadoAnaliticoForm.linha_origem">
          </div>

          <div class="check-row">
            <label><input type="checkbox" [(ngModel)]="achadoAnaliticoForm.confirmado"> Confirmado</label>
            <label><input type="checkbox" [(ngModel)]="achadoAnaliticoForm.revisado"> Revisado</label>
          </div>

          <div class="field full">
            <label>Descrição</label>
            <textarea rows="4" [(ngModel)]="achadoAnaliticoForm.descricao"></textarea>
          </div>

          <div class="field full">
            <label>Evidência textual</label>
            <textarea rows="3" [(ngModel)]="achadoAnaliticoForm.evidencia"></textarea>
          </div>

          <div class="field full">
            <label>Recomendação</label>
            <textarea rows="3" [(ngModel)]="achadoAnaliticoForm.recomendacao"></textarea>
          </div>
        </div>

        <div class="quesito-actions">
          <button type="button" class="btn-light" (click)="achadoFormVisivel = false">Cancelar</button>
          <button type="button" class="btn-primary" (click)="salvarAchadoAnalitico()">Salvar achado</button>
        </div>
      </div>

      <div class="analitico-table">
        <div class="analitico-head achados-head">
          <div>ID</div><div>Código</div><div>Execução</div><div>Tipo</div><div>Gravidade</div><div>Descrição</div><div>Evidência</div><div>Confirmado</div><div>Revisado</div><div>Ações</div>
        </div>

        <div class="analitico-row achados-row" *ngFor="let a of achadosAnaliticos()">
          <div><strong>{{ a.id }}</strong></div>
          <div><strong>{{ a.codigo || '-' }}</strong></div>
          <div>{{ a.execucao_id }}</div>
          <div>{{ a.tipo_achado }}</div>
          <div><span class="status-pill" [ngClass]="classeStatus(a.gravidade)">{{ a.gravidade }}</span></div>
          <div>{{ a.descricao }}</div>
          <div>{{ a.evidencia || '-' }}</div>
          <div>{{ simNao(a.confirmado) }}</div>
          <div>{{ simNao(a.revisado) }}</div>
          <div class="row-actions">
            <button type="button" class="btn-mini danger" (click)="excluirAchadoAnalitico(a)">Excluir</button>
          </div>
        </div>

        <div class="vazio" *ngIf="achadosAnaliticos().length === 0">Nenhum achado analítico cadastrado para esta perícia.</div>
      </div>
    </div>
  </ng-container>
  </ng-template>

  <ng-template #evidenciasAnaliticasTpl>
  <ng-container *ngIf="abaAtiva() === 'Evidências'; else laudoAnaliticoTpl">
    <div class="secao-registros secao-analitica">
      <div class="section-title">
        <div>
          <h2>Matriz de evidências</h2>
          <p>Registros em pericia.matriz_evidencias vinculados à perícia selecionada.</p>
        </div>
        <button type="button" class="btn-primary" (click)="novaEvidenciaMatriz()">Novo item</button>
      </div>

      <div class="analitico-form-card" *ngIf="evidenciaFormVisivel">
        <div class="form-card-title">Nova evidência / matriz</div>

        <div class="analitico-grid">
          <div class="field">
            <label>Quesito ID</label>
            <input type="number" [(ngModel)]="evidenciaMatrizForm.quesito_id">
          </div>

          <div class="field">
            <label>Documento ID</label>
            <input type="number" [(ngModel)]="evidenciaMatrizForm.documento_id">
          </div>

          <div class="field">
            <label>Papel de trabalho ID</label>
            <input type="number" [(ngModel)]="evidenciaMatrizForm.papel_trabalho_id">
          </div>

          <div class="field">
            <label>Procedimento</label>
            <input [(ngModel)]="evidenciaMatrizForm.procedimento">
          </div>

          <div class="field full">
            <label>Achado</label>
            <textarea rows="4" [(ngModel)]="evidenciaMatrizForm.achado"></textarea>
          </div>

          <div class="field full">
            <label>Conclusão</label>
            <textarea rows="4" [(ngModel)]="evidenciaMatrizForm.conclusao"></textarea>
          </div>

          <div class="field full">
            <label>Limitação</label>
            <textarea rows="3" [(ngModel)]="evidenciaMatrizForm.limitacao"></textarea>
          </div>
        </div>

        <div class="quesito-actions">
          <button type="button" class="btn-light" (click)="evidenciaFormVisivel = false">Cancelar</button>
          <button type="button" class="btn-primary" (click)="salvarEvidenciaMatriz()">Salvar evidência</button>
        </div>
      </div>

      <div class="analitico-table">
        <div class="analitico-head evidencias-head">
          <div>ID</div><div>Código</div><div>Quesito</div><div>Documento</div><div>Papel</div><div>Procedimento</div><div>Achado</div><div>Conclusão</div><div>Limitação</div><div>Ações</div>
        </div>

        <div class="analitico-row evidencias-row" *ngFor="let m of evidenciasMatriz()">
          <div><strong>{{ m.id }}</strong></div>
          <div><strong>{{ m.codigo || '-' }}</strong></div>
          <div>{{ m.quesito_id || '-' }}</div>
          <div>{{ m.documento_id || '-' }}</div>
          <div>{{ m.papel_trabalho_id || '-' }}</div>
          <div>{{ m.procedimento || '-' }}</div>
          <div>{{ m.achado || '-' }}</div>
          <div>{{ m.conclusao || '-' }}</div>
          <div>{{ m.limitacao || '-' }}</div>
          <div class="row-actions">
            <button type="button" class="btn-mini danger" (click)="excluirEvidenciaMatriz(m)">Excluir</button>
          </div>
        </div>

        <div class="vazio" *ngIf="evidenciasMatriz().length === 0">Nenhum registro de evidência/matriz cadastrado para esta perícia.</div>
      </div>
    </div>
  </ng-container>
  </ng-template>

  <ng-template #laudoAnaliticoTpl>
  <ng-container *ngIf="abaAtiva() === 'Checklist'; else laudoWordTpl">
    <div class="secao-registros secao-analitica checklist-unico">
      <div class="section-title">
        <div>
          <h2>Checklist do Laudo</h2>
          <p>Checklist único da perícia. Marque os itens conforme forem conferidos. Ao finalizar, a aba Laudo fica liberada para prévia e download.</p>
        </div>
        <button type="button" class="btn-primary" (click)="salvarLaudoChecklist()">Salvar checklist</button>
      </div>

      <div class="checklist-status-card">
        <div>
          <strong>Status do checklist</strong>
          <span class="status-pill" [ngClass]="classeStatus(laudoChecklistForm.status || 'Em elaboração')">
            {{ laudoChecklistForm.status || 'Em elaboração' }}
          </span>
        </div>
        <div>
          <strong>Situação do laudo</strong>
          <span class="status-pill" [ngClass]="checklistLaudoFinalizado() ? classeStatus('Concluído') : classeStatus('Pendente')">
            {{ checklistLaudoFinalizado() ? 'Liberado para laudo' : 'Checklist pendente' }}
          </span>
        </div>
      </div>

      <div class="analitico-form-card checklist-form-sempre-visivel">
        <div class="analitico-grid">
          <div class="field">
            <label>Status</label>
            <select class="status-select" [ngClass]="classeStatus(laudoChecklistForm.status || 'Em elaboração')" [(ngModel)]="laudoChecklistForm.status">
              <option *ngFor="let status of statusLaudoChecklist" [value]="status">{{ status }}</option>
            </select>
          </div>

          <div class="check-row full checklist-grid checklist-grid-unico">
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.laudo_concluido"> Laudo concluído/revisado internamente</label>
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.comunicacao_assistente"> Comunicação com assistente técnico verificada</label>
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.diligencia_conjunta"> Diligências necessárias tratadas</label>
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.checklist_objeto_ok"> Objeto pericial conferido</label>
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.checklist_quesitos_ok"> Quesitos conferidos/respondidos</label>
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.checklist_documentos_ok"> Documentos conferidos</label>
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.checklist_evidencias_ok"> Evidências/matriz conferidas</label>
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.checklist_calculos_ok"> Cálculos/memórias conferidos</label>
            <label><input type="checkbox" [(ngModel)]="laudoChecklistForm.checklist_limitacoes_ok"> Limitações ressalvadas</label>
          </div>

          <div class="field full">
            <label>Observações do checklist</label>
            <textarea rows="4" [(ngModel)]="laudoChecklistForm.observacoes" placeholder="Registre pendências, ressalvas ou observações antes de liberar o laudo."></textarea>
          </div>
        </div>

        <div class="quesito-actions">
          <button type="button" class="btn-primary" (click)="salvarLaudoChecklist()">Salvar checklist</button>
        </div>
      </div>
    </div>
  </ng-container>
  </ng-template>


  <ng-template #laudoWordTpl>
  <ng-container *ngIf="abaAtiva() === 'Laudo'; else esclarecimentosTpl">
    <div class="secao-registros secao-laudo-word">
      <div class="laudo-word-card">
        <div class="section-title">
          <div>
            <h2>Laudo / Respostas Finais</h2>
            <p>Visualize a prévia, baixe o Word e registre versões ajustadas.</p>
          </div>
          <div class="button-group">
            <button type="button" class="btn-light" [disabled]="!checklistLaudoFinalizado()" (click)="visualizarLaudoWord()">Visualizar prévia</button>
            <button type="button" class="btn-primary" [disabled]="!checklistLaudoFinalizado()" (click)="baixarLaudoWord()">Baixar Word</button>
          </div>
        </div>

        <div class="alert aviso" *ngIf="!checklistLaudoFinalizado()">
          Finalize e salve o checklist antes de visualizar ou baixar o laudo.
        </div>

        <div class="vazio" *ngIf="carregandoLaudoWord">Gerando prévia do laudo...</div>

        <div class="laudo-preview" *ngIf="laudoWordPreview">
          <div class="laudo-preview-top">
            <div>
              <h3>{{ laudoWordPreview.titulo }}</h3>
              <p>{{ laudoWordPreview.subtitulo }}</p>
            </div>
            <button type="button" class="btn-mini" (click)="limparPreviewLaudoWord()">Limpar prévia</button>
          </div>

          <div class="laudo-secao" *ngFor="let secao of laudoWordPreview.secoes">
            <h4>{{ secao.titulo }}</h4>
            <p *ngFor="let paragrafo of secao.paragrafos">{{ paragrafo }}</p>
          </div>
        </div>
      </div>

      <div class="laudo-word-card">
        <div class="section-title">
          <div>
            <h2>Anexar versão alterada</h2>
            <p>Depois de baixar e ajustar o Word, registre a versão final ou revisada no histórico da perícia.</p>
          </div>
        </div>

        <div class="anexo-laudo-grid">
          <div class="field">
            <label>Arquivo Word/PDF</label>
            <input type="file" accept=".doc,.docx,.pdf" (change)="selecionarArquivoLaudo($event)">
          </div>

          <div class="field">
            <label>Descrição da versão</label>
            <input [(ngModel)]="descricaoVersaoLaudo" placeholder="Ex.: Laudo revisado após diligência">
          </div>

          <div class="field anexo-laudo-action">
            <label>&nbsp;</label>
            <button type="button" class="btn-primary" (click)="anexarVersaoLaudo()">Anexar versão</button>
          </div>
        </div>

        <div class="laudo-versoes" *ngIf="versoesLaudoAnexadas().length">
          <h3>Versões registradas</h3>
          <div class="laudo-versao-row" *ngFor="let doc of versoesLaudoAnexadas()">
            <strong>{{ doc.codigo || 'DOC' }}</strong>
            <span>{{ doc.descricao || doc.tipo_documento }}</span>
            <span class="status-pill" [ngClass]="classeStatus(doc.status)">{{ doc.status }}</span>
          </div>
        </div>

        <div class="vazio" *ngIf="versoesLaudoAnexadas().length === 0">
          Nenhuma versão alterada do laudo registrada ainda.
        </div>
      </div>
    </div>
  </ng-container>
  </ng-template>

  <ng-template #esclarecimentosTpl>
  <ng-container *ngIf="abaAtiva() === 'Esclarecimentos'; else fallbackOutrasAbasTpl">
    <div class="secao-esclarecimentos">
      <div class="section-title">
        <div>
          <h2>Esclarecimentos ao Laudo</h2>
          <p>Controle posterior ao laudo: pedidos do juízo, árbitro ou partes e respectivas respostas técnicas.</p>
        </div>
        <button type="button" class="btn-primary" (click)="novoEsclarecimento()">Novo esclarecimento</button>
      </div>

      <div class="esclarecimento-form-card">
        <div class="form-card-title">{{ esclarecimentoEditandoId ? 'Editar esclarecimento' : 'Novo esclarecimento' }}</div>
        <div class="esclarecimento-grid">
          <div class="field"><label>Data do pedido</label><input type="date" [(ngModel)]="esclarecimentoForm.dataPedido"></div>
          <div class="field"><label>Origem</label><select [(ngModel)]="esclarecimentoForm.origem"><option *ngFor="let origem of origensEsclarecimento" [value]="origem">{{ origem }}</option></select></div>
          <div class="field"><label>Prazo</label><input type="date" [(ngModel)]="esclarecimentoForm.prazo"></div>
          <div class="field"><label>Status</label><select [(ngModel)]="esclarecimentoForm.status"><option *ngFor="let status of statusEsclarecimento" [value]="status">{{ status }}</option></select></div>
          <div class="field wide"><label>Ponto questionado</label><textarea rows="3" [(ngModel)]="esclarecimentoForm.pontoQuestionado"></textarea></div>
          <div class="field wide"><label>Resposta / esclarecimento</label><textarea rows="4" [(ngModel)]="esclarecimentoForm.resposta"></textarea></div>
          <div class="field wide"><label>Documento vinculado</label><input [(ngModel)]="esclarecimentoForm.documentoVinculado" placeholder="Ex.: DOC-010, petição, despacho ou versão do laudo"></div>
        </div>
        <div class="quesito-actions"><button type="button" class="btn-light" (click)="novoEsclarecimento()">Limpar</button><button type="button" class="btn-primary" (click)="salvarEsclarecimento()">{{ esclarecimentoEditandoId ? 'Salvar alteração' : 'Registrar esclarecimento' }}</button></div>
      </div>

      <div class="esclarecimentos-table">
        <div class="esclarecimentos-head"><div>Data</div><div>Origem</div><div>Ponto</div><div>Prazo</div><div>Status</div><div>Ações</div></div>
        <div class="esclarecimentos-row" *ngFor="let e of esclarecimentos()">
          <div>{{ e.dataPedido || '-' }}</div><div>{{ e.origem }}</div><div><strong>{{ e.pontoQuestionado }}</strong><small>{{ e.documentoVinculado }}</small></div><div>{{ e.prazo || '-' }}</div><div><span class="status-pill" [ngClass]="classeStatus(e.status)">{{ e.status }}</span></div><div class="row-actions"><button type="button" class="btn-mini" (click)="editarEsclarecimento(e)">Editar</button><button type="button" class="btn-mini danger" (click)="excluirEsclarecimento(e)">Excluir</button></div>
        </div>
        <div class="vazio" *ngIf="esclarecimentos().length === 0">Sem pedido de esclarecimento posterior ao laudo.</div>
      </div>
    </div>
  </ng-container>
  </ng-template>

  <ng-template #fallbackOutrasAbasTpl>
    <div class="secao-registros">
      <div class="section-title">
        <h2>{{ abaAtiva() }}</h2>
        <button type="button" class="btn-primary">Novo item</button>
      </div>

      <div class="sheet-table" *ngIf="registrosDaAba().length; else semItensTpl">
        <div class="sheet-head"><div>Título</div><div>Descrição</div><div>Status</div></div>
        <div class="sheet-row" *ngFor="let item of registrosDaAba()">
          <div><strong>{{ item.titulo }}</strong></div><div>{{ item.descricao }}</div><div><span class="status-pill" [ngClass]="classeStatus(item.status || 'Registrado')">{{ item.status || 'Registrado' }}</span></div>
        </div>
      </div>

      <ng-template #semItensTpl><div class="vazio">Nenhum item cadastrado nesta aba.</div></ng-template>
    </div>
  </ng-template>
</ng-template>
      </ng-container>
    </ng-template>
  </div>

  </ng-container>

  <ng-template #loadingTpl><div class="panel"><div class="vazio">Carregando dados...</div></div></ng-template>
  <ng-template #vazioTpl><div class="vazio">Nenhuma perícia cadastrada. Clique em <strong>Nova perícia</strong>.</div></ng-template>
</div>
